export const impactAsync = async () => null;
export const ImpactFeedbackStyle = {};
export const selectionAsync = async () => null;
export const notificationAsync = async () => null;
